import { Link } from "react-router-dom";
import topics from "./topics";
import Subscribe from "./Subscribe";
import useTitle from "./useTitle";

const LEVEL_ZH = { s3: "中三", s4: "中四", s5: "中五", s6: "中六" };
// public/pdf/<level>/<level>-math-notes-chi.pdf is this page's formulas and mistakes typeset with the EX
// header and watermark (built outside the repo from topics.js, exported with Google Docs): rebuild it
// whenever a level's formulas or mistakes change, and update its size here.
const NOTES_PDF = { s3: "256 KB", s4: "238 KB", s5: "251 KB", s6: "196 KB" };

// A revision sheet: every chapter of one year on a single page, laid out so
// that printing it (or saving it as PDF) gives something usable on paper.
const NotesPage = ({ level }) => {
    const list = topics.filter((t) => t.level === level);
    const zh = LEVEL_ZH[level];
    useTitle(`${zh}數學筆記 PDF ${level.toUpperCase()} Maths Notes｜公式總表＋常犯錯誤`);

    return (
        <div className="notes-page">
            <p className="crumb no-print">
                <Link to="/">Home</Link> › <Link to={`/${level}`}>{zh}數學練習</Link> › 筆記
            </p>

            <h1>{zh}數學筆記（{list.length} 個課題）</h1>
            <h2 className="topic-en">{level.toUpperCase()} Maths Notes — Formulas &amp; Common Mistakes</h2>

            <p className="topic-intro">
                {zh}數學（必修部分）全年課題的重點公式同常犯錯誤，一版睇晒。
                想要紙本可以下載整理好嘅筆記 PDF，或者撳「列印／儲存為 PDF」印呢一版，印出嚟係乾淨嘅溫習紙，冇導覽列同按鈕。
                每個課題都有對應嘅免費練習 PDF，撳課題標題就入到去。
            </p>

            <div className="notes-actions no-print">
                <a className="notes-pdf" href={`/pdf/${level}/${level}-math-notes-chi.pdf`} target="_blank" rel="noreferrer">下載筆記 PDF（{NOTES_PDF[level]}）</a>
                <button type="button" onClick={() => window.print()}>列印／儲存為 PDF</button>
                <Link to={`/${level}`}>下載{zh}練習 PDF →</Link>
            </div>

            {list.map((t) => (
                <section className="notes-topic" key={t.slug}>
                    <h3>
                        <span className="notes-ch">Ch {t.ch}</span>
                        <Link to={`/${level}/${t.slug}`}>{t.zh} {t.en}</Link>
                    </h3>
                    <p className="notes-intro">{t.intro}</p>

                    <h4>重點公式</h4>
                    <table className="topic-formulas">
                        <tbody>
                            {t.formulas.map(([label, body]) => (
                                <tr key={label}><th>{label}</th><td>{body}</td></tr>
                            ))}
                        </tbody>
                    </table>

                    <h4>常犯錯誤</h4>
                    <ul className="topic-mistakes">
                        {t.mistakes.map((m, n) => <li key={n}>{m}</li>)}
                    </ul>
                </section>
            ))}

            <div className="no-print">
                <Subscribe where={`${level}-notes`} />
            </div>

            <p className="notes-foot">
                Math-EXE · math-exe.com · {zh}數學筆記 · 免費練習 PDF 中英雙版
            </p>
        </div>
    );
}

export default NotesPage;
